// extracted by mini-css-extract-plugin
module.exports = {"element":"side-by-side_element__3e_gc"};